import PropTypes from 'prop-types';
import React from 'react';
import Logo from '~app/components/Survey/Logo';
import './header.scss';

const Header = ({ logo }) => {
  return (
    <header className="sm-header--container" data-testid="Header__Container">
      <Logo logo={logo} />
    </header>
  );
};

Header.propTypes = {
  logo: PropTypes.shape({}),
};

Header.defaultProps = {
  logo: null,
};

export default Header;
